'use client';
import { ApolloNextAppProvider } from '@apollo/experimental-nextjs-app-support';
import { LoadingOverlay } from '@mantine/core';
import { SupabaseContext, useManageUser } from '@shady-pines/api';
import { Suspense } from 'react';
import { apollo } from '@web/graphql/client';
import { supabase as supabaseClient } from '@web/graphql/client';

type AppLayoutProps = {
  children: React.ReactNode;
};

const supabaseProviderProps = { supabase: supabaseClient };

const AppLayoutInner = ({ children }: AppLayoutProps) => {
  useManageUser('web');
  return <ApolloNextAppProvider makeClient={() => apollo()}>{children}</ApolloNextAppProvider>;
};

export const AppLayout = ({ children }: AppLayoutProps) => {
  return (
    <Suspense fallback={<LoadingOverlay visible />}>
      <SupabaseContext.Provider value={supabaseProviderProps}>
        <AppLayoutInner>{children}</AppLayoutInner>
      </SupabaseContext.Provider>
    </Suspense>
  );
};
